import React from 'react';
import styled, { css } from 'styled-components';
import { Classable, HasChildren, Shapeable, Post } from '@shapeable/types';
import { breakpoints, theme } from '@shapeable/theme';
import { ComponentPropsProvider, PostBannerLayout, useEntity } from '@shapeable/ui';
import { classNames } from '@shapeable/utils';

const cls = classNames('post-layout');

// -------- Types -------->

export type PostLayoutProps = Classable & HasChildren & { 
  entity?: Post;
};

export const PostLayoutDefaultProps: Omit<PostLayoutProps, 'entity'> = {
};

// -------- Child Component Props -------->

type ContainerProps = {

}

// -------- Styles -------->

const ContainerStyles = breakpoints({
  base: css`
  
  `,
});


// -------- Components -------->

const My = {
  Layout: styled(PostBannerLayout)<ContainerProps>`${ContainerStyles}`,
};

export const PostLayout: Shapeable.FC<PostLayoutProps> = (props) => {
  const { className, children } = props;
  const entity = useEntity(props.entity);
  
  return (
      <My.Layout className={cls.name(className)} entity={entity} headerProps={{ variant: 'overlay'}} />
  )
};

PostLayout.defaultProps = PostLayoutDefaultProps;
PostLayout.cls = cls;